import heartReaction from "../../images/reactions/heart-reaction.gif";
import hahaReaction from "../../images/reactions/haha-reaction.gif";
import likeReaction from "../../images/reactions/like-reaction.gif";
import thanksReaction from "../../images/reactions/thanks-reaction.png";
import sadReaction from "../../images/reactions/sad-reaction.gif";
import saluteReaction from "../../images/reactions/salute-reaction.gif";
import checkReaction from "../../images/reactions/check-reaction.gif";

import fireReaction from "../../images/reactions/fire-reaction.gif";
import snakeReaction from "../../images/reactions/snake-reaction.gif";
import chainReaction from "../../images/reactions/chain-reaction.gif";
import dollarReaction from "../../images/reactions/dollar-reaction.gif";
import armyReaction from "../../images/reactions/Army.gif";
import truckReaction from "../../images/reactions/trucking.gif";
import warehouseReaction from "../../images/reactions/warehouse.gif";
import moneybagReaction from "../../images/reactions/money-bag.gif";
import roosterReaction from "../../images/reactions/rooster.gif";
import vesselReaction from "../../images/reactions/vessel.gif";

import dragonReaction from "../../images/reactions/dragon-reaction.png";
import tigerReaction from "../../images/reactions/tiger-reaction.png";

import React, { useState, useRef, useEffect, useContext } from "react";

function ReactionsIndicator({ reaction, reaction_details, isThread }) {
  const [showReactionList, setShowReactionList] = useState(false);

  const handleMouseEnter = () => {
    setShowReactionList(true);
  };

  const handleMouseLeave = () => {
    setShowReactionList(false);
  };

  let reactionImg;
  switch (reaction) {
    case "haha":
      reactionImg = hahaReaction;
      break;
    case "heart":
      reactionImg = heartReaction;
      break;
    case "like":
      reactionImg = likeReaction;
      break;
    case "thanks":
      reactionImg = thanksReaction;
      break;
    case "sad":
      reactionImg = sadReaction;
      break;
    case "salute":
      reactionImg = saluteReaction;
      break;
    case "checked":
      reactionImg = checkReaction;
      break;
    case "fire":
      reactionImg = fireReaction;
      break;
    case "snake":
      reactionImg = snakeReaction;
      break;
    case "chain":
      reactionImg = chainReaction;
      break;
    case "dollar":
      reactionImg = dollarReaction;
      break;
    case "tiger":
      reactionImg = tigerReaction;
      break;
    case "dragon":
      reactionImg = dragonReaction;
      break;
    case "army":
      reactionImg = armyReaction;
      break;
    case "truck":
      reactionImg = truckReaction;
      break;
    case "warehouse":
      reactionImg = warehouseReaction;
      break;
    case "moneybag":
      reactionImg = moneybagReaction;
      break;
    case "rooster":
      reactionImg = roosterReaction;
      break;
       case "vessel":
      reactionImg = vesselReaction;
      break;
  }

  return (
    <div
      className="centered-items chat-reactions-border"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <img src={reactionImg} className="like-reaction" />
      <small className="reactions-indicator">{reaction_details?.length}</small>
      {showReactionList && (
        <div
          className={`reactions-list ${isThread ? "thread-reaction-list" : ""}`}
        >
          {reaction_details?.map((reactor, index) => (
            <div className="reaction-user" key={index}>
              {reactor?.user?.display_name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ReactionsIndicator;
